// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-specialties-js": () => import("./../../../src/pages/specialties.js" /* webpackChunkName: "component---src-pages-specialties-js" */),
  "component---src-pages-unit-js": () => import("./../../../src/pages/unit.js" /* webpackChunkName: "component---src-pages-unit-js" */)
}

